module.exports = __webpack_public_path__ + "static/media/Mail.776bec14.svg";